import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { addExtraReducer } from '../../../../store/addExtraReducer'
import { LoadingStatusEnum } from '../../../../store/types'
import { SortDirectionCapital } from '../../../../types'
import {
  AccountFiltersEnum,
  profitabilityAccountFilterByTag,
  profitabilityAccountFilters,
} from '../api/types'

import initialState from './initialState'
import { GetAccountsReducer } from './reducers'
import { SLICE_NAME, GetAccounts } from './thunks'

import type { TraderProfitabilityTag } from '../../../../user/traderProfitability'

const AccountsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    // updateColumnOrder: (state, action) => {
    //   state.pagination.columns = action.payload
    // },
    updatePageSize: (state, action) => {
      state.loading = LoadingStatusEnum.Pending
      state.pagination.page = 1
      state.pagination.perPage = action.payload
    },
    updatePage: (state, action) => {
      state.loading = LoadingStatusEnum.Pending
      state.pagination.page = action.payload
    },
    updateOrderBy: (state, action) => {
      state.loading = LoadingStatusEnum.Pending
      state.pagination.page = 1
      state.pagination.order = SortDirectionCapital.asc
      state.pagination.orderBy = action.payload
    },
    updateSortOrder: (state, action) => {
      state.loading = LoadingStatusEnum.Pending
      state.pagination.page = 1
      state.pagination.order = action.payload
    },
    updateSearch: (state, action: PayloadAction<string>) => {
      state.loading = LoadingStatusEnum.Pending
      state.pagination.page = 1
      state.pagination.search = action.payload
    },
    toggleFilter: (state, action: PayloadAction<AccountFiltersEnum>) => {
      state.loading = LoadingStatusEnum.Pending
      const filter = action.payload
      const filters = state.pagination.filters

      state.pagination.filters = filters.includes(filter)
        ? filters.filter((f) => f !== filter)
        : [...filters, filter]

      state.pagination.page = 1
    },
    setProfitabilityTags: (state, action: PayloadAction<TraderProfitabilityTag[]>) => {
      state.loading = LoadingStatusEnum.Pending
      const nonProfitabilityFilters = state.pagination.filters.filter(
        (filter) => !profitabilityAccountFilters.includes(filter as AccountFiltersEnum),
      )
      const profitabilityFilters = action.payload.map((tag) => profitabilityAccountFilterByTag[tag])

      state.pagination.filters = [...nonProfitabilityFilters, ...profitabilityFilters]
      state.pagination.page = 1
    },
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetAccounts, GetAccountsReducer)
    // addExtraReducer(builder, SetAccountCfdStatus, SetAccountCfdStatusReducer)
  },
})

export const {
  updatePageSize,
  updatePage,
  updateOrderBy,
  updateSortOrder,
  updateSearch,
  toggleFilter,
  setProfitabilityTags,
} = AccountsSlice.actions

export default AccountsSlice.reducer
